import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import SharedGPATabelConverter from "./SharedGPATabelConverter";
const TITLE = "Tableau de conversion de la moyenne cumulative GPA";
const DESCRIPTION =
  "Tableau de conversion de la moyenne cumulative GPA pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "tableau de conversion de la moyenne cumulative gpa, calculatrice tableau de conversion de la moyenne cumulative gpa, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gpatableconverter";
function GPATabelConverter() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <div className="row">
        <div className="col">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <SharedGPATabelConverter />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <SecondAds />
        <br />
        <MainCalculatorsList></MainCalculatorsList>
        <br />
      </div>
      {" "}
      <br />
    </div>
  );
}
export default GPATabelConverter;
